// extracted by mini-css-extract-plugin
export default {"root":"classes_root__uOs1M","title-container":"classes_title-container__LCL4h"};